import * as React from "react";
import { useContext } from "react";

import NewGifLoader from "../../Assets/AI-Prompt/Experian-T.gif";
import styled from "styled-components";
import { UserContext } from "../UserProvider";
import "./commonloader.css";

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
`;

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CommonLoader = () => {

  return (
    <LoaderContainer className="commonloader">
      <Loading>
        <img src={NewGifLoader} alt="Loading animation" style={{height:'150px'}} width={"100%px"}/>
        {/* <svg id="dots" width="132px" height="58px" viewBox="0 0 132 58" xmlns="http://www.w3.org/2000/svg">
          <circle id="dot1" cx="25" cy="30" r="13" fill="#E80070" />
          <circle id="dot2" cx="65" cy="30" r="13" fill="#255AF0" />
          <circle id="dot3" cx="105" cy="30" r="13" fill="#C1188B" />
        </svg> */}
      </Loading>
    </LoaderContainer>
  );
};

export default CommonLoader;
